require('./brokerETFBuyStep2.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');

// @commons
const StocksBuySellSummary = require('components/broker/commons/stocksBuySellSummary/stocksBuySellSummary');
const { OKMessage } = require('commonsComponents/OKMessage');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');

// @ Utils
const { recordLinkV2 } = require("utilities/tagging");

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const {
    BROKER_STOCKS_BUY_SELL_SUMMARY_BUY_MODIFIER,
    FIRST_STEP,
    SECOND_STEP,
    CHARGE_ACCOUNT_PREFIX,
    TYPE_ETFS,
    BROKER_CONVENIENCE_MIFID_TEST_ETF_ID,
    BROKER_MIFID_VERSION_1,
    BROKER_PRODUCT_TYPE_ETFS_ES,
} = require('constants/index');

const {BROKER_ETF_BUY_ID} = require('constants/operationTypes');

// @ components
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;
const { LoadingSection } = require('commonsComponents/loadingSection');
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING, CONFIRMATION_SCRIPT_AGREEMENT } = require('components/contactCenter/confirmScript/confirmationScript');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const BrokerLegalDocumentation = require('components/broker/brokerLegalDocumentation/brokerLegalDocumentation');
const ExantCostETF = require('components/broker/brokerETFBuy/brokerETFBuyStep2/components/exantCostETF.js')


class BrokerETFBuyStep2 extends React.Component {
    constructor(props) {
        super(props);
        this.buildMifidDisclaimer = this.buildMifidDisclaimer.bind(this);

        this.state = {
            allowClickCheckbox: false,
            showDisclaimer: false,
        }
    }

    componentWillUnmount() {
        const { resetCheckbox } = this.props;
        resetCheckbox();
    }

    buildMifidDisclaimer() {
        const { immBrokerConvenienceMiFIDTest, immBrokerMiFIDProducts, productFile } = this.props;
        const usingMifidv1 = immBrokerConvenienceMiFIDTest.get('mifidVersion') === BROKER_MIFID_VERSION_1;
        const notComplex = !productFile.get('isComplex');

        if (usingMifidv1 && notComplex) {
            const fundMifidId = BROKER_CONVENIENCE_MIFID_TEST_ETF_ID;

            if (immBrokerMiFIDProducts.getIn(['products', fundMifidId, 'loading'])) {
                return <LoadingSection/>;
            } else {
                const mifidDisclaimer = immBrokerMiFIDProducts.getIn(['products', fundMifidId, 'disclaimer']);

                return (
                    <div className="etf-buy-step2__mifid-disclaimer">
                        <FormattedText value="broker-etfBuyStep2MifdDisclaimerSubTitle" className="etf-buy-step2__subtitle"/>
                        {mifidDisclaimer}
                    </div>
                );
            }
        }
    }

    handleChangeDocumentCheckbox() {
        const { toggleDocumentsCheckbox, immETFBuy } = this.props;
        if(this.state.allowClickCheckbox || !immETFBuy.get('dfiUrl')) {
            const step2 = immETFBuy.get('steps').get(SECOND_STEP);
            recordLinkV2({
                categoriaEvento: "datos fundamentales inversor etps",
                accionEvento: "checkBox",
                etiquetaEvento: !step2.get('documentsCheckbox') ? "acepta" : "no acepta"
            });
            toggleDocumentsCheckbox();
            this.setState({
                showDisclaimer: false,
            });
        }else {
            this.setState({
                showDisclaimer: true,
            });
        }
    }

    buildDocumentSection() {
        const {
            toggleRiskCheckbox,
            immETFBuy,
            productFile,
            isCryptoETF,
        } = this.props;
        const step2 = immETFBuy.get('steps').get(SECOND_STEP);
        const productIsin = productFile.get('isinCode')
        const productDefinition = productFile.get('companyName')
        const documentsCheckboxValue = step2.get('documentsCheckbox')
        const riskCheckboxValue = step2.get('riskCheckbox')
        if(!__CONTACT_CENTER__) {
            const tealium = {
                categoriaEvento: "datos fundamentales inversor etps",
                accionEvento: "clickButton",
                etiquetaEvento: "leer"
            };
            return(
                <section>
                    <BrokerLegalDocumentation
                        className="hire-investment-step2__documentation-box"
                        isin={productIsin}
                        productDefinition={productDefinition}
                        productType={BROKER_PRODUCT_TYPE_ETFS_ES}
                        reportCompleted={() => this.setState({ allowClickCheckbox: true })}
                        tealium={tealium}
                    />
                    <div className="etf-buy-step2__disclaimer-read-documents">
                        { this.state.showDisclaimer &&
                            <OKMessage
                                type="warning"
                                className="etf-buy-step2__footer-text no-print-out"
                            >
                                <FormattedText value="broker-etfBuyStep2DisclaimerDocuments" />
                            </OKMessage>
                        }
                    </div>
                    <div className="etf-buy-step2__link-read-documents">
                        <OKCheckbox
                            onChange={() => this.handleChangeDocumentCheckbox()}
                            idName="read-Documents"
                            label={formatText('broker-etfBuyStep2CheckboxDocuments')}
                            value={documentsCheckboxValue}
                        />
                    </div>
                    <div className="etf-buy-step2__link-read-documents">
                        { isCryptoETF &&
                            <OKCheckbox
                                onChange={()=>toggleRiskCheckbox()}
                                idName="etf-risk"
                                label={formatText('broker-etfBuyStep2CheckboxRisk')}
                                value={riskCheckboxValue}
                                disabled={!documentsCheckboxValue}
                            />
                        }
                    </div>
                </section>
            );
        }
    }


    render() {
        const {
            productFile,
            immETFBuy,
            immStocksContracts,
            isCryptoETF,
            immFeatureFlags,
            fetchExtantCostETFBuy
        } = this.props;
        const showExantCostETFBuy = immFeatureFlags.get('wealth_etfs_buy_show_costs')
        const step1 = immETFBuy.get('steps').get(FIRST_STEP);
        const step2 = immETFBuy.get('steps').get(SECOND_STEP);
        const stocksContractSelectedValue = immETFBuy.getIn([
            'steps',
            FIRST_STEP,
            'stocksContractSelectedValue'
        ]);
        const stockContract = immStocksContracts.get(stocksContractSelectedValue);
        const contractNumber = stockContract.get('walletNumber');
        const productNumber = stockContract.get('productNumber');
        const chargeAccount = `${CHARGE_ACCOUNT_PREFIX}${productNumber}${contractNumber}`;
        const titlesAmount = immETFBuy.get("confirmationData").titulosImporteAproximado;
        const mifidDisclaimer = this.buildMifidDisclaimer();
        const dfiFetching = immETFBuy.get('dfiFetching');
        const operationParams = {
            bondsNumber: titlesAmount,
            chargeAccount: chargeAccount
        };
        const operative = formatText('operatives-PurchaseETF');
        const productCurrency = productFile.get('currency');
        if(dfiFetching) {
            return <LoadingSection/>;
        }
        const documentSection = this.buildDocumentSection()
        const documentsCheckboxValue = step2.get('documentsCheckbox')
        const riskCheckboxValue = step2.get('riskCheckbox')
        return (
            <div className="etf-buy-step2" id="printable-wizard">
                <header className="etf-buy-step2__header">
                    <h2 className="etf-buy-step2__header-title">
                        <FormattedText value="broker-etfBuyStep2HeaderTitle" />
                    </h2>
                    <ContactCenterRender>
                        <ConfirmationScript
                            operative={operative}
                            confirmationType={CONFIRMATION_SCRIPT_GREETING}
                        />
                    </ContactCenterRender>
                    <p className="stocks-sell-step2__header-info">
                        <FormattedText value="broker-etfBuyStep2HeaderText" />
                    </p>
                </header>
                {showExantCostETFBuy ? (
                    <section className="etf-buy-step2__section">
                        <ExantCostETF
                            productCurrency={productCurrency}
                            productIso={productFile.get("micCode")}
                            productType={TYPE_ETFS}
                            stockContract={stockContract}
                            stockDescription={productFile.get("companyName")}
                            step1={step1}
                            fetchExtantCostETFBuy={fetchExtantCostETFBuy}
                            immETFBuy={immETFBuy}
                        />
                    </section>
                ) : (
                    <section className="etf-buy-step2__section">
                        <StocksBuySellSummary
                            productName={formatText("broker-etfSummaryProductName")}
                            productCurrency={productCurrency}
                            productIso={productFile.get("micCode")}
                            productType={TYPE_ETFS}
                            stockContract={stockContract}
                            stockDescription={productFile.get("companyName")}
                            step1={step1}
                            modifier={
                                BROKER_STOCKS_BUY_SELL_SUMMARY_BUY_MODIFIER
                            }
                            titlesQuantityTitle="stocksBuySellSummaryTitlesQuantityParticipations"
                        />
                    </section>
                )}

                <footer className="etf-buy-step2__section">
                    <div className="col-lg-12">
                        <div className="etf-buy-step2__disclaimer">
                            <OKMessage
                                id="etf-buy-step2-disclaimer"
                                type="informative"
                                visible={true}
                            >
                                <FormattedText value="broker-etfBuyStep2DisclaimerParagraph1" />
                                <FormattedText value="broker-etfBuyStep2DisclaimerParagraph2" />
                            </OKMessage>
                        </div>
                    </div>
                    {mifidDisclaimer}
                    <p className="etf-buy-step2__footer-text no-print-out">
                        <FormattedText value="broker-etfBuyStep2FooterText" />
                    </p>
                    {documentSection}
                    <section className="etf-buy-step2__signature-pattern-section">
                        <ContactCenterRender>
                            <ConfirmationScript
                                confirmationType={CONFIRMATION_SCRIPT_AGREEMENT}
                            />
                        </ContactCenterRender>
                        {(__CONTACT_CENTER__ ||
                            (documentsCheckboxValue &&
                                (riskCheckboxValue || !isCryptoETF))) && (
                                <SignaturePattern
                                    operationType={BROKER_ETF_BUY_ID}
                                    operationParams={operationParams}
                                />
                        )}
                    </section>
                </footer>
            </div>
        );
    }
}

BrokerETFBuyStep2.propTypes = {
    productFile: PropTypes.object.isRequired,
    immETFBuy: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object.isRequired,
    handleTermsChecked: PropTypes.func.isRequired,
    getDFI: PropTypes.func.isRequired,
    toggleDocumentsCheckbox: PropTypes.func.isRequired,
    toggleRiskCheckbox: PropTypes.func.isRequired,
    resetCheckbox: PropTypes.func.isRequired,
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    immBrokerMiFIDProducts: PropTypes.object.isRequired,
    isCryptoETF: PropTypes.bool.isRequired,
    immFeatureFlags: PropTypes.object.isRequired,
    fetchExtantCostETFBuy: PropTypes.func.isRequired,
};

module.exports.constructor = BrokerETFBuyStep2;
module.exports.BrokerETFBuyStep2 = connect(
    state => ({
        immBrokerConvenienceMiFIDTest: state.brokerConvenienceMiFIDTest,
        immBrokerMiFIDProducts: state.brokerMiFIDProducts
    }))(BrokerETFBuyStep2);
